export default "__VITE_ASSET__umCuMVe2__$_?url__"